
const mqtt_url =window.API_CONFIG.API_MQTT;
const mqtt_username = window.AUTH_CONFIG.API_MQTT_USERNAME;
const mqtt_password =window.AUTH_CONFIG.API_MQTT_PASSWORD; 
const baseUrl = window.API_CONFIG.API_URL;
const apiConfig = {
    baseUrl:baseUrl,
    api_loginurl:baseUrl + "/auth/login",
    api_getClients : baseUrl + "/getClients",
    api_session : baseUrl + "/sessions", //session recording api
    api_division : baseUrl + "/client/plant/divisions",
    api_lines : baseUrl + "/client/plant/division/lines",
    api_ssh_connect : baseUrl + "/ssh/connect",
    api_sshGenerateKeyPair : baseUrl + "/ssh/generateKeyPair",
    api_device_deployed:baseUrl + "/devices/deployed",
    api_machines : baseUrl + "/client/plant/division/line/machines",
    api_acceptrequest : baseUrl + "/shellhub/device/acceptRequest",
    api_device_pending : baseUrl + "/devices/pending",
    api_deleteuser : baseUrl + "/user/deleteUser",
    api_getusers : baseUrl + "/getUsers",
    api_updateclient : baseUrl + "/user/update_client_access",
    api_userregister : baseUrl + "/registerUser",
    api_dispatchdevice : baseUrl + "/dispatchDevice",
    api_alldevices : baseUrl + "/get/allDevices",
    api_getdispatchedDevice : baseUrl + "/get/dispatchedDevice",
    api_currentShift : baseUrl + "/client/plant/currentshift",
    api_devicereturn : baseUrl + "/device/return",
    api_devicereplacement : baseUrl + "/device/replacement",
    api_scrabdevice : baseUrl + "/scrap/device",
    api_scrabdevices : baseUrl + "/get/scrap/devices",
    api_sshconnect : baseUrl + "/ssh/connect",
    api_allsessions : baseUrl + "/all/session/recording",
    api_deletesessions : baseUrl + "/delete/session/recording",
    api_refreshMaster : baseUrl + "/fetchClients",
    api_mqttUrl:mqtt_url,
    api_mqttusername:mqtt_username,
    api_mqttpassword:mqtt_password,
    api_updatetracking:baseUrl + "/update/tracking",
    api_pendingDevices:baseUrl + "/get/allDevices/dispatched",
    api_trackingDevice:baseUrl + "/device/",
    api_createApiKey:baseUrl + "/createApiKey",
    api_getApiKeys:baseUrl + "/getApiKeys",
    api_deleteApiKey:baseUrl + "/deleteApiKey",
    api_mfaGenerateSecret:baseUrl + "/mfa/generateSecret",
    api_mfaConfirm:baseUrl + "/mfa/confirm",
    api_verifyMfaLogin:baseUrl + "/auth/verify-mfa",
    api_firstLoginSetPassword:baseUrl + "/auth/first-login/set-password",
    api_vaultSetup:baseUrl + "/vault/setup",
    api_vaultStatus:baseUrl + "/vault/status",
    api_vaultPassword:baseUrl + "/vault/password",
    api_vaultDelete:baseUrl + "/vault/delete"
};

export default  apiConfig